module.exports = require('./helpers/bundle-url').getBundleURL('cweZv') + "logo-dark.eefe0b7f.svg";